<template>
    <div class="box">
        <div class="form">
            <van-field v-if="detail.detail" label="退货方式" :value="detail.detail.finalRefundStr" readonly />
            <!-- <van-field
                readonly
                center
                clearable
                label="处理人员"
                :value="disposalDetails.optName"
            >
            <template #button>
                <a class="call-icon" @click="util.callConfirm('拨打该号码？', reviewDetail.optContactTel)" href="javascript:void(0)" />
            </template>
            </van-field> -->
            <van-field v-if="detail.detail.finalRefundTypes == 2" label="退货地点" :value="disposalDetails.ServicePoint" readonly />
            <!-- <van-field
                readonly
                rows="2"
                autosize
                label="补充说明"
                type="textarea"
                show-word-limit
                :value="disposalDetails.memo || '无'"
            /> -->
            <div class="myfield">
                <div class="label">补充说明</div>
                <div class="content">{{disposalDetails.memo || '无'}}</div>
            </div>
            <van-field label="处置机构" :value="disposalDetails.optMechanismName" readonly />
            <div class="my-field">
                <div class="label">处置人员</div>
                <div class="content">
                    <span>{{ disposalDetails.optName }}</span>
                    <a class="call-icon" @click="util.callConfirm('拨打该号码？', disposalDetails.optContactTel, 6)" href="javascript:void(0)" />
                </div>
            </div>
            <!-- <van-field
                readonly
                center
                clearable
               :value="disposalDetails.optName"
                label="处置人员"
                >
                <template #button>
                <a class="call-icon" @click="util.callConfirm('拨打该号码？', disposalDetails.optContactTel)" href="javascript:void(0)" />
                </template>
            </van-field> -->
            <van-field label="处置时间" :value="disposalDetails.time" readonly />
        </div>
        <!-- <div class="form">
            <van-field label="处置机构" :value="disposalDetails.optMechanismName" readonly />
            <div class="my-field">
                <div class="label">处置人员</div>
                <div class="content">
                    <span>{{ disposalDetails.optName }}</span>
                    <a class="call-icon" @click="util.callConfirm('拨打该号码？', disposalDetails.optContactTel, 6)" href="javascript:void(0)" />
                </div>
            </div>
            <van-field
                readonly
                center
                clearable
               :value="disposalDetails.optName"
                label="处置人员"
                >
                <template #button>
                <a class="call-icon" @click="util.callConfirm('拨打该号码？', disposalDetails.optContactTel)" href="javascript:void(0)" />
                </template>
            </van-field>
            <van-field label="处置时间" :value="disposalDetails.time" readonly />
        </div> -->

    </div>
</template>

<script>
    import util from '../../../../utils/common'

    export default {
        data () {
            return {
                detail: {},
                disposalDetails: {
                    ServicePoint: ''
                } // 处置详情
            }
        },
        created () {
            this.detail = this.$store.state.refund.detail
            console.log(this.detail)
            this.setDetail()
        },
        methods: {
            setDetail () {
                const refundOption = {
                    2: '现场退货',
                    1: '邮寄退货'
                }
                if (this.detail && this.detail.history) {
                    this.disposalDetails = this.detail.history.find(i => i.optText === '已同意受理')
                    this.disposalDetails.time = util.getStampInDate(this.disposalDetails.creatTime, '/')
                }
                if (this.detail && this.detail.centerOrder) {
                    if (this.detail.centerOrder.length > 0) {
                        if (this.detail.centerOrder.find(i => i.relType == 1)) {
                            this.disposalDetails.ServicePoint = this.detail.centerOrder.find(i => i.relType == 1).centerName
                        } else {
                            this.disposalDetails.ServicePoint = this.detail.centerOrder[0].centerName
                        }
                    }
                }
                this.detail.detail.finalRefundStr = refundOption[this.detail.detail.finalRefundTypes]
            }
        }
    }
</script>

<style lang="less" scoped>
    .box {
        padding: 16px 16px 34px;
        background-color: #f8f9fc;
        min-height: 100vh;
        /deep/.form {
            background-color: white;
            margin-bottom: 16px;
            border-radius: 4px;
            .myfield {
                display: flex;
                align-items: flex-start;
                font-size: 14px;
                padding: 10px 16px;

                .label {
                    font-size: 14px;
                    color: #646566;
                    margin-right: 16px;
                    white-space: nowrap;
                }
                .content {
                    color: #323233;
                    line-height: 18px;
                }
            }

            .van-field__label {
                width: 56px;
                margin-right: 16px;
            }
             .van-cell::after {
                border-bottom: 0.1px solid #ebedf0;
            }
             .my-field {
                background-color: white;
                display: flex;
                align-items: center;
                padding: 10px 0;
                margin: 0 16px;
                border-bottom: 0.1px solid #ebedf0;

                .label {
                    color: #646566;
                    font-size: 14px;
                    width: 56px;
                    margin-right: 16px;
                }
                .content {
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    color: #323233;
                    span {
                        margin-right: 10px;
                    }
                }
            }
            .call-icon {
                display: inline-block;
                width: 25px;
                height: 25px;
                background-color: #e9f7f1;
                background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAA/5JREFUSEutll1sFFUUx/9nZit1d4mRvkHACC8akyZCaJESbBPRsFttDLaJJoKBSHgCgtuWaAhXfah2iyViIEaM3zHY+KC7tUCElqiBjhATwkcIRh/kgYQQa7Lb2u7OHL0z95a7012BXc/DZu8kc37zP5+XUMmEsLBXMAgM+StN/q/RAkdhkwACNx5LxeqL1sPRaPTCWJv42wfXCJ0LlMqE8FqO9ywszvDnzNxGFh3J5WMbL3aJmVqhpUCloOXb3iVFcjMMNAIoAoiA+IDTvm/7/wdUsBWZrVGb7suCuU3BbAAeABsR6nLWp4c6v+q0h7qG3GrSeUuhCmVzNrWTGYMACgDqlFMJtABccRFffu5pMVmt0gCo1LWOivqpfP4SMz/oP5V1ecuCs0UvOMn0l9WqDBxqdSO9a7jonlJqwhGTIbRhWe84yf5XWkdFZKxNyPzelflA/bWrhnu2eZ53qIK6II82bXIS6U9rUqi/tmk4tRcehCoSmTNtOoefJc7FXxJCyHNV5ivUwJXZ1B5ivBEC+rkjwsF7Y/EdfhhrGAAlIW3Odm9m5g+NkAaFQnTDXlB84PTqwalaYMF0NKp05dHeR6jg/mK0Q6AONFFH9tIf29/6s6o4Gi+VTBoZ2sncpAN4jxphVe3ALzvJfYerLRbNnAVqR82Z7h0M3j870gDVDjgfnYk/PvasmKglrHMmzWOZ1xa5mJa9uMxQ6UPJQt94cuBV3bdlw3ubVVYS0jIqdTso3wTbwvrTyfTROaGVoNcFyU0zO0z0Pq2UQ/18xdn36yLXfx1l5hZDpYZfA2Ot88zA77NQA7Ymu/v++nnsfb/u7b/8SISgFfdh80iqkYs4CaAhDCWin7g+0uE80XdT93BQcPldRLwHTHmysPtMIv2JL8JQXnbj6y9vyvZsAnsfh0ZdUESgE/PsyPM/JPputI6K+FQud5CBF0t6mOi9xNnYTjm6tNLyVwyjN5sy3YcA3lZuXRHRVWYcBnEHGKsRVLQeifJ/BKAvGuzFW0YS26dldVcGqg3y5LFUbGLGOgJ4SeVQLmRpoYLyz9Kf9in7N4ASDTrt6V3/DTRUtnzTM79o89fMvM64BUjH2qlUZQ57XX96p7rkYfl4x8D5ygr1K0qpn6d87iNmPKeglSBmewb5JlxlorU/J9PXbw/USuWehqDvhvNvgrlbzVsZRh1a05d8JtVFAFy2yNpwpr3/smyTOwNqqCrvpmzvU8TufgYeClWweVEmsug4iLaMJ/qv6el050AF7RzqtOSNTV6SowXaCMYGD7wUwCIA96hC+Q2W9UEDTb07kjgwbU6luwOGoPIonf0xf9li1ysssQkxeFRwiS7IfPlD3hx3/77wDzb0+y46N1GhAAAAAElFTkSuQmCC);
                background-repeat: no-repeat;
                background-size: 60% 60%;
                background-position: center;
                border-radius: 50%;}
        }
    }
</style>
